import { gql } from '@apollo/client'

export const moneyFragment = gql`
  fragment money on Money {
    fractionDigits
    centAmount
    currencyCode
  }
`
